import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { isAdDisabled } from 'common/selectors/appSelector';

class AdContainer extends Component {
    constructor(props) {
        super(props);
        // state is maintained by AdManager
        this.state = {
            refreshed: false
        };
    }

    componentDidMount() {
        if (!this.props.disabled && this.context.watchAdManager) {
            this.context.watchAdManager.addInstance(this);
        }
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.ads.id === nextProps.ads.id) {
            return false;
        }
        return true;
    }

    componentWillUnmount() {
        if (!this.props.disabled) {
            this.context.watchAdManager.removeInstance(this);
        }
    }

    render() {
        const {
            className,
            collapseBeforeLoad,
            exclude,
            id,
            include,
            inView,
            isOutOfPage,
            kvps,
            refreshWhenVisible,
            slotType,
            disabled,
            render
        } = this.props;

        const slotKvps = [];
        const adProps = { id, key: id };

        /* no type no ad */
        if (disabled || slotType === null) {
            return null;
        }

        /* default if pos not specified */
        if (typeof kvps.pos === 'undefined') {
            kvps.pos = slotType;
        }

        /* build key value pair string */
        Object.keys(kvps).forEach((key) => {
            if (key !== null && kvps.k !== null) {
                slotKvps.push(`${key}=${kvps[key]}`);
            }
        });

        /* build up the div properties */
        adProps.className = classNames('react-ad', className, {
            'ad-slot': !inView
        });

        adProps['data-slot-type'] = slotType;

        if (isOutOfPage) {
            adProps['data-out-of-page'] = 'true';
        }

        if (collapseBeforeLoad) {
            adProps['data-collapse-before-load'] = 'true';
        }

        if (include.length > 0) {
            const includeStr = include.join(',');
            adProps['data-include-bp'] = includeStr;
        }

        if (exclude.length > 0) {
            const excludeStr = exclude.join(',');
            adProps['data-exclude-bp'] = excludeStr;
        }

        if (slotKvps.length > 0) {
            const kvpsStr = slotKvps.join(',');
            adProps['data-slot-kvps'] = kvpsStr;
        }

        if (refreshWhenVisible === false) {
            adProps['data-refresh-on-pageload'] = 'true';
        }

        return (
            render(<div ref="adSlot" {...adProps} />)
        );
    }
}

AdContainer.defaultProps = {
    className: '',
    exclude: [],
    include: [],
    inView: false,
    kvps: {},
    refreshWhenVisible: false,
    slotType: null,
    disabled: false,
    render: children => children
};

AdContainer.propTypes = {
    ads: PropTypes.object,
    refreshWhenVisible: PropTypes.bool,
    className: PropTypes.string,
    collapseBeforeLoad: PropTypes.bool,
    exclude: PropTypes.array,
    id: PropTypes.string,
    include: PropTypes.array,
    inView: PropTypes.bool,
    isOutOfPage: PropTypes.bool,
    kvps: PropTypes.object,
    slotType: PropTypes.string,
    disabled: PropTypes.bool,
    render: PropTypes.func
};

AdContainer.contextTypes = {
    watchAdManager: PropTypes.object
};

const mapStateToProps = (state) => ({
    ads: state.ads,
    disabled: isAdDisabled(state)
});

export default connect(mapStateToProps)(AdContainer);



// WEBPACK FOOTER //
// ./app/common/ads/AdContainer.js